var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"type-selector"},[_c('span',{class:{
      'type-selector__item': true,
      'type-selector__item--active': _vm.value === 'start' || _vm.value === 'end'
    },on:{"click":_vm.setRangeMode}},[(_vm.fallbackVersion)?[_vm._v("Daty wylot - przylot")]:[_vm._v("Wyjazd od - do")]],2),_vm._v(" "),(_vm.fallbackVersion)?_c('span',{class:{
      'type-selector__item': true,
      'type-selector__item--active': _vm.value === 'date'
    },on:{"click":_vm.setDayAndRangeMode}},[_vm._v("\n    Wylot od + liczba dni\n  ")]):_c('span',{class:{
      'type-selector__item': true,
      'type-selector__item--active': _vm.value === 'month'
    },on:{"click":_vm.setMonthMode}},[_vm._v("\n    Cały miesiąc\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24ba797f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/TypeSelector.vue
// module id = 618
// module chunks = 1